import { render, staticRenderFns } from "./DraggableJourneySteps.vue?vue&type=template&id=74687dfb&"
import script from "./DraggableJourneySteps.vue?vue&type=script&lang=ts&"
export * from "./DraggableJourneySteps.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableJourneySteps.vue?vue&type=style&index=0&id=74687dfb&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports